//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The status of communication being sent to recipient */
export const CommunicationRecipientStatus = {
    /** Communication has not yet been sent to recipient */
    Pending: 0,

    /** Communication was successfully delivered to recipient's mail server */
    Delivered: 1,

    /** Communication failed to be sent to recipient */
    Failed: 2,

    /** Communication was cancelled prior to sending to the recipient */
    Cancelled: 3,

    /** Communication was sent and opened (viewed) by the recipient */
    Opened: 4,

    /** Temporary status used while sending ( to prevent transaction and job sending same record ) */
    Sending: 5
} as const;

/** The status of communication being sent to recipient */
export const CommunicationRecipientStatusDescription: Record<number, string> = {
    0: "Pending",

    1: "Delivered",

    2: "Failed",

    3: "Cancelled",

    4: "Opened",

    5: "Sending"
};

/** The status of communication being sent to recipient */
export type CommunicationRecipientStatus = typeof CommunicationRecipientStatus[keyof typeof CommunicationRecipientStatus];
